// extracted by mini-css-extract-plugin
module.exports = {"shell":"NotificationShell_shell__wyLfc"};